"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeRichTextDescription = exports.RICH_TEXT_DESCRIPTION_ALLOWED_TAGS = void 0;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
exports.RICH_TEXT_DESCRIPTION_ALLOWED_TAGS = [
    "p",
    "br",
    "span",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "sub",
    "sup",
    "a",
    "ul",
    "ol",
    "li",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "hr",
    "code",
    "pre",
];
const TEXT_ALIGN_VALUES = [/^(left|right|center|justify|start|end)$/];
const LINE_HEIGHT_VALUES = [/^[0-9.]+(px|em|rem|%)?$/];
const RICH_TEXT_DESCRIPTION_OPTIONS = {
    allowedTags: exports.RICH_TEXT_DESCRIPTION_ALLOWED_TAGS,
    allowedAttributes: {
        "*": ["class", "dir", "style"],
        a: ["href", "target", "rel", "class", "dir", "style"],
    },
    allowedStyles: {
        "*": {
            "text-align": TEXT_ALIGN_VALUES,
            "line-height": LINE_HEIGHT_VALUES,
        },
    },
    allowedSchemes: ["http", "https", "mailto"],
    allowProtocolRelative: false,
    disallowedTagsMode: "discard",
};
const sanitizeRichTextDescription = (html) => {
    if (!html) {
        return html;
    }
    return (0, sanitize_html_1.default)(html, RICH_TEXT_DESCRIPTION_OPTIONS);
};
exports.sanitizeRichTextDescription = sanitizeRichTextDescription;
